import { render } from "./clubcard-online.html?vue&type=template&id=a96f17a4&scoped=true&ts=true"
import script from "./clubcard-online.vue?vue&type=script&lang=ts"
export * from "./clubcard-online.vue?vue&type=script&lang=ts"

import "./clubcard-online.scss?vue&type=style&index=0&id=a96f17a4&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96f17a4"]])

export default __exports__